import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import {
  getAppleStoreLink,
  getAppLinkInBox,
  isAndroid,
  isIOS
} from '../../../common/utils/appLinkUtil';

export default function ModuleBox(props) {
  const router = useRouter();
  const subtitleText = useRef(null);
  const hyperLink = useRef(null);
  const imgUrl =
    props.m_img_url === undefined
      ? 'https://via.placeholder.com/384x216'
      : props.m_img_url;

  const imgDesc = props.imgDesc === undefined ? '이미지 설명' : props.imgDesc;

  const mainTitle = props.main_title;
  const date = props.date === undefined ? undefined : props.date;
  // const buttons = props.buttons === undefined ? undefined : props.buttons;
  const [buttons, setButtons] = useState([]);

  if (subtitleText?.current) {
    subtitleText.current.innerHTML = props.desc || '';
  }

  function checkClickParams(index, linkUrl, color) {
    //TODO childmild  해당 부분  box 확인하여 작업 필요함ㄴ

    const key = 'div';
    let value = '';
    if (index === 0) {
      value = 'main_top_home';
    } else {
      value = 'main_top_menu';
    }

    if (color === 'red') {
      value = 'main_top_live_app';
    }

    if (linkUrl.indexOf('http') === -1) {
      router.query[key] = value;

      const parameter = Object.keys(router.query)
        .map(function (x) {
          return (
            encodeURIComponent(x) + '=' + encodeURIComponent(router.query[x])
          );
        })
        .join('&');

      if (color === 'red') {
        if (isAndroid()) {
          linkUrl =
            `${linkUrl}&${parameter}` +
            '#Intent;scheme=sbsplayer;package=kr.co.sbs.videoplayer;end';
        } else if (isIOS()) {
          linkUrl = `${linkUrl}?${parameter}`;
        }
      }
    } else {
      const httpUrl = new URL(linkUrl);
      const httpUrlSearchParams = httpUrl.searchParams;
      
      httpUrlSearchParams.set(key, value);
      httpUrl.search = httpUrlSearchParams.toString();
      try {
        var findQ = linkUrl.indexOf('?');
        if(findQ!==-1){
           const originalurl = linkUrl.substring(0, linkUrl.indexOf('?'));
           linkUrl = `${originalurl}${httpUrl.search}`;
           linkUrl = linkUrl.replace(/\+/g, "%20");
        }else{
          linkUrl = `${linkUrl}${httpUrl.search}`;
          linkUrl = linkUrl.replace(/\+/g, "%20");
        }
      } catch (error) {
        console.error(error);
      }
    }

    //TODO moduleBox 일때는 여기서 판단해야함
    return linkUrl;
  }

  useEffect(() => {
    if (Array.isArray(props.buttons) && props.buttons.length > 0) {
      const buttonList = props.buttons.map((item) => {
        if (item.link?.indexOf('/live/') > -1) {
          const channelId = item.link
            .split('/')
            .pop()
            .split('#')[0]
            .split('?')[0];
          item.link = getAppLinkInBox(channelId);
        }
        return item;
      });
      setButtons(buttonList);
    } else {
      setButtons([]);
    }
  }, []);

  const onClickLink = () => {
    if (isIOS()) {
      //IOS 일때
      let checkAppInstall, clickTimer;
      let eventclearTimers = function () {
        clearInterval(checkAppInstall);
        clearTimeout(clickTimer);
      };

      let intervalCheckHidden = function () {
        if (document.webkitHidden || document.hidden) {
          //console.log('clear - app installed.');
          eventclearTimers();
        }
      };

      checkAppInstall = setInterval(intervalCheckHidden, 200);

      clickTimer = setTimeout(function () {
        if (
          hyperLink?.current &&
          hyperLink.current.href.indexOf('sbsplayer://') === 0
        ) {
          window.location = getAppleStoreLink();
        }
      }, 3000);
    }
    // location.href = linkUrl;
  };

  return (
    <>
      <div className="mvsl_cont">
        {mainTitle && (
          <em
            className="mvsl_text_title"
            dangerouslySetInnerHTML={{ __html: mainTitle }}
          />
        )}
        {props.desc && (
          <strong
            tabIndex={props.view ? '0' : '-1'}
            className="mvsl_text_subtitle"
            ref={subtitleText}
          />
        )}
        {date && <p className="mvsl_subinfo">{date}</p>}
        <div
          className={`${buttons === undefined ? '' : 'btn_roundtype_w'}`}
          onTouchMove={(e) => props.moveTouchPause(e)}
        >
          {buttons &&
            buttons.map((item, index) => {
              // 여기서는 앵커 태그를 사용하자 앵커아니고 Link 사용시 오류남
              return (
                <a
                  target={
                    item.home_link_new_yn === 'Y' ||
                    item.menu_link_new_yn === 'Y'
                      ? '_blank'
                      : ''
                  }
                  key={index}
                  href={`${checkClickParams(index, item.link, item.color)}`}
                  ref={hyperLink}
                  onClick={onClickLink}
                  className={`btn_roundtype_color_${
                    item.color === undefined ? 'white' : item.color
                  }`}
                >
                  <span className="btn_rtc_text">{item.text}</span>
                </a>
              );
            })}
        </div>
      </div>
      <i
        className="mvsl_bg"
        style={{
          backgroundImage: `url('${
            imgUrl || 'https://via.placeholder.com/150x150?text=SBS'
          }')`
        }}
      />
    </>
  );
}
